<!-- ----------------------------------------------- -->
<template>
  <v-col
    class="tm-mb-frame-content"
    v-if="tmStageList.length !== 0 && tmStageList.tmStgDetailInfo.ofcCd"
  >
    <tm-stage-info></tm-stage-info>
    <v-card class="com-mb-card tm-mb-datail-card">
      <div class="com-mb-card-contents">
        <div class="tm-mb-detail-tab-btn">
          <v-btn
            v-if="hasXsec && showCross && hasZeroHighFix"
            class="vc-tab-btn"
            small
            depressed
            :class="{ 'btn-on': tabIndex === 0 }"
            @click="setTabIndex(0)"
            >{{ text.tab.cross }}</v-btn
          >
          <v-btn
            class="vc-tab-btn"
            small
            depressed
            :class="{ 'btn-on': tabIndex === 1 }"
            @click="setTabIndex(1)"
            >{{ text.tab.graph }}</v-btn
          >
          <v-btn
            v-if="hasCctvInfo"
            class="vc-tab-btn"
            small
            depressed
            :class="{ 'btn-on': tabIndex === 2 }"
            @click="setTabIndex(2)"
            >{{ text.tab.cctv }}</v-btn
          >
          <v-btn
            v-if="hasValues"
            class="vc-tab-btn"
            small
            depressed
            :class="{ 'btn-on': tabIndex === 3 }"
            @click="setTabIndex(3)"
            >{{ text.tab.list }}</v-btn
          >
        </div>
        <div class="tm-box-list" ref="graphFrame">
          <div v-if="tabIndex === 0 && showCross && hasZeroHighFix">
            <!-- 拡大表示 -->
            <tm-stage-x-sec-dlg
              v-if="modalDiagCross"
              @close="closeModalCross"
              :isHour="timeMode"
              :isExpansion="scalModeXSec"
              :isLegend="isLegendDisp"
            ></tm-stage-x-sec-dlg>
            <tm-stage-x-sec
              v-if="!modalDiagCross"
              @modalDiagCross="openModalCross"
              :isHour="timeMode"
              :isExpansion="scalModeXSec"
              :isLegend="isLegendDisp"
            ></tm-stage-x-sec>
          </div>
          <div v-if="tabIndex === 1">
            <!-- 拡大表示 -->
            <tm-stage-graph-dlg
              v-if="modalDiag"
              @close="closeModal"
              :isHour="timeMode"
              :isExpansion="scalModeGraph"
              :isLegend="isLegendDisp"
            ></tm-stage-graph-dlg>
            <v-touch v-on:doubletap="openModal">
              <tm-stage-graph
                :width="graphWidth"
                :isHour="timeMode"
                :isExpansion="scalModeGraph"
                :isLegend="isLegendDisp"
                :showRain="showRain"
                :height="checkPred ? 180 : 150"
                :heightPct="checkPred ? 80 : 100"
              ></tm-stage-graph>
            </v-touch>
          </div>
          <div v-if="tabIndex === 2">
            <!-- 拡大表示 -->
            <tm-cctv-dlg
              v-if="modalDiagCctv"
              @close="closeModalCctv"
            ></tm-cctv-dlg>
            <v-touch v-on:doubletap="openModalCctv">
              <tm-cctv></tm-cctv>
            </v-touch>
          </div>
        </div>
        <tm-stage-values v-if="tabIndex === 3"></tm-stage-values>
        <tm-switch-btn
          :tabIndex="tabIndex"
          :dispContentsSwitch="dispContentsSwitch"
          v-if="dispContentsSwitch"
        ></tm-switch-btn>
      </div>
    </v-card>
    <tm-stage-curt></tm-stage-curt>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]水位 フレーム
 * TmStageFrame.vue
 * @author ILUKE
 */

import TmStageInfo from "./TmStageInfo.vue";
import TmStageCurt from "./TmStageCurt.vue";
import TmStageXSec from "./TmStageXSec.vue";
import TmStageGraph from "./TmStageGraph.vue";
import TmCctv from "./TmCctv.vue";
import TmCctvDlg from "./TmCctvDlg.vue";
import TmStageGraphDlg from "./TmStageGraphDlg.vue";
import TmStageXSecDlg from "./TmStageXSecDlg.vue";
import TmStageValues from "./TmStageValues.vue";
import TmSwitchBtn from "./TmSwitchBtn.vue";
import tmObs from "./../../lib/tmObs.js";
import PageLog from "./../../lib/pageLog.js";

export default {
  name: "tm-stage-frame",
  components: {
    TmStageInfo,
    TmStageCurt,
    TmStageXSec,
    TmStageGraph,
    TmCctv,
    TmStageValues,
    TmCctvDlg,
    TmStageGraphDlg,
    TmStageXSecDlg,
    TmSwitchBtn,
  },
  data() {
    return {
      /** 観測詳細タブ */
      tabIndex: 0,
      /** 文字列リソース */
      text: {
        title_detail: "観測詳細",
        title_curt: "最新観測値",
        tab: {
          cross: "横断図",
          graph: "グラフ",
          cctv: "カメラ",
          list: "観測値",
        },
      },
      showRain: true,
      dispContentsSwitch: false,
      modalDiag: false,
      modalDiagCross: false,
      modalDiagCctv: false,
      graphWidth: 350,
    };
  },
  created: function() {
    this.loadTmObs();
    this.setWarningIcon();
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  updated() {
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    // アクセスログ用パラメータ破棄
    this.$store.commit("Telemeter/setPageLogParam", null);
    this.$store.commit("Telemeter/resetHistoryPrintCurrentPicture");
  },
  computed: {
    // リクエストパラメータ
    reqParam: {
      get() {
        return this.$store.state.Telemeter.selectedTmParam;
      },
    },
    /** 対象日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /** 観測日時(ファイル取得用) */
    appTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
    // 通常水位取得
    tmStageList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    surface: {
      get() {
        return this.$store.state.Telemeter.surface;
      },
    },
    // 横断図拡縮表示設定 取得
    scalModeXSec: {
      get() {
        return this.$store.state.Telemeter.scalModeXSec;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalModeXSec", val);
      },
    },
    // グラフ拡縮表示設定 取得
    scalModeGraph: {
      get() {
        return this.$store.state.Telemeter.scalModeGraph;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalModeGraph", val);
      },
    },
    // 表示時刻設定 取得
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setTimeMode", val);
      },
    },
    /** 凡例表示状態 取得 */
    isLegendDisp: {
      get() {
        return this.$store.state.Telemeter.isLegendDisp;
      },
      set(val) {
        this.$store.commit("Telemeter/setLegendDisp", val);
      },
    },

    // 河川カメラ情報を持っているか
    hasCctvInfo: {
      get() {
        const selectedTm = this.$store.state.Telemeter.selectedTm;
        return tmObs.hasCctvInfo(selectedTm);
      },
    },
    // 横断図情報を持っているか
    hasXsec: {
      get() {
        const selectedTm = this.$store.state.Telemeter.selectedTm;
        return tmObs.hasXsec(selectedTm);
      },
    },
    // 零点高の値を持っているかどうか
    hasZeroHighFix: {
      get() {
        const selectedTm = this.$store.state.Telemeter.selectedTm;
        return tmObs.hasZeroHighFix(selectedTm);
      },
    },
    showCross: {
      get() {
        return !this.$store.state.Telemeter.crossSvgError;
      },
    },
    // 観測値を持っているか
    hasValues: {
      get() {
        if (this.tmStageList.obsValues.min10.values.length > 0) {
          return true;
        }
        return false;
      },
    },
    // 簡易版判定
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
    /**
     *  予測水位が存在するか
     */
    checkPred: {
      get() {
        if (this.$store.state.Telemeter.selectedTm.graph.crntPredTime == null) {
          return false;
        }
        return true;
      },
    },
    appTimeControlFlg: {
      get() {
        return this.$store.state.Telemeter.historyImageSlider.appTimeControlFlg;
      },
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam: {
      get() {
        if (
          this.$store.state.Telemeter.pageLogParam &&
          this.$store.state.Telemeter.pageLogParam.obsData
        ) {
          return {
            prefCd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo
              .prefCd,
            twnCd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo
              .twnCd,
            rvrCd: this.$store.state.Telemeter.pageLogParam.obsData.obsInfo
              .rvrCd,
            obsCd: this.$store.state.Telemeter.pageLogParam.payload.obsFcd,
            appTime: this.$store.state.Telemeter.pageLogParam.payload.appTime,
          };
        }
        return null;
      },
    },
  },
  methods: {
    openModal() {
      this.modalDiag = true;
    },
    closeModal() {
      this.modalDiag = false;
    },
    openModalCross() {
      this.modalDiagCross = true;
    },
    closeModalCross() {
      this.modalDiagCross = false;
    },
    openModalCctv() {
      this.modalDiagCctv = true;
    },
    closeModalCctv() {
      this.modalDiagCctv = false;
    },
    // 通常水位を取得
    getTmStageDatas() {
      setTimeout(() => {
        this.$store
          .dispatch("Telemeter/getSelectedTm", {
            ofcCd: this.reqParam.ofcCd,
            itmkndCd: this.reqParam.itmkndCd,
            obsCd: this.reqParam.obsCd,
            appTime: this.appTime,
            appTimeRound: this.appTimeRound,
          })
          .then(() => {
            // タブ初期値
            if (this.hasXsec && this.hasZeroHighFix) {
              // 河川横断図
              this.setTabIndex(0);
            } else {
              // 水位グラフ
              this.setTabIndex(1);
            }
          });
      }, 500);
    },
    // URLパラメータチェック
    checkUrlParam(to, from) {
      if (
        from.query.fld !== to.query.fld ||
        from.query.ofcCd !== to.query.ofcCd ||
        from.query.itmkndCd !== to.query.itmkndCd ||
        from.query.obsCd !== to.query.obsCd
      ) {
        return true;
      }
      return false;
    },
    setTabIndex(tabIndex) {
      this.tabIndex = tabIndex;
      this.setContentsSwitch(tabIndex);
    },
    /**
     * 表示切替ボタン制御
     */
    setContentsSwitch(tabIndex) {
      this.dispContentsSwitch = false;
      if (tabIndex === 0) {
        // 河川横断図表示
        this.dispContentsSwitch = true;
      } else if (tabIndex === 1) {
        // グラフ表示
        // データが0件の場合はフッタを表示しない
        if (
          this.tmStageList.length !== 0 &&
          (this.tmStageList.graph.hour.value.length > 0 ||
            this.tmStageList.graph.min10.value.length > 0)
        ) {
          this.dispContentsSwitch = true;
        }
      } else if (tabIndex === 3) {
        this.dispContentsSwitch = true;
      } else {
        this.dispContentsSwitch = false;
      }
    },
    // ワーニングアイコン表示
    setWarningIcon() {
      let isDispWarningIcon = false;
      if (this.tmStageList.warningFlg) {
        isDispWarningIcon = true;
      }
      this.$emit("dispWarningIcon", isDispWarningIcon);
    },
    /**
     * 画面更新処理
     */
    loadTmObs() {
      // 横断図エラー情報クリア
      this.$store.commit("Telemeter/setCrossSvgError", false);
      // 選択中テレメータ情報クリア
      this.$store.commit("Telemeter/setSelectedTm", []);
      // グラフ状態クリア
      this.$store.commit("Telemeter/resetTmObs");
      // お知らせ・河川予警報ダイアログ非表示
      this.$store.commit("map/hideInfoRw");
      this.getTmStageDatas();
    },
    handleResize() {
      this.$nextTick(() => {
        if (this.$refs.graphFrame !== undefined) {
          const offsetWidth = this.$refs.graphFrame.offsetWidth;
          if (offsetWidth > 0) {
            this.graphWidth = offsetWidth - 8;
          }
        }
      });
    },
    setDispCross() {
      if (!this.showCross) {
        this.setTabIndex(1);
      }
    },
  },
  watch: {
    tmStageList() {
      // 雨量観測所がない場合は、グラフ非表示
      if (
        this.tmStageList.length !== 0 &&
        !this.tmStageList.tmStgDetailInfo.reprnOfcCd
      ) {
        this.showRain = false;
      } else {
        this.showRain = true;
      }
      // 水位上昇フラグを更新
      this.setWarningIcon();
    },
    // 観測所遷移 監視
    $route(to, from) {
      if (this.checkUrlParam(to, from)) {
        this.loadTmObs();
      }
    },
    // 観測日時を監視
    appTimeRound() {
      if (this.appTimeControlFlg) {
        this.$store.commit("Telemeter/setAppTimeControlFlg", false);
      } else {
        this.loadTmObs();
      }
    },
    // 観測詳細タブを監視
    tabIndex() {
      if (this.tabIndex === 0) {
        this.setDispCross();
      }
    },
    showCross() {
      this.setDispCross();
    },
    /* アクセスログ出力用パラメータ */
    pageLogParam(to, from) {
      if (
        to &&
        (!from || to.obsCd != from.obsCd || to.appTime != from.appTime)
      ) {
        // アクセスログ出力
        PageLog.log({
          page_log: "stg",
          pref_cd: to.prefCd,
          twn_cd: to.twnCd,
          rvr_cd: to.rvrCd,
          obs_cd: to.obsCd,
          device_sb: this.$store.state.app.mode,
          fc_flg: this.$store.getters["app/isFldCtl"],
        });
      }
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
